// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 11703-优惠活动新增 POST /web/v1/promotion/add */
export async function addSwimPromotion(
  body: API.SwimPromotionAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/promotion/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11705-优惠活动删除 GET /web/v1/promotion/delete/${param0} */
export async function deleteSwimPromotion(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSwimPromotionParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/promotion/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11702-优惠活动详情 GET /web/v1/promotion/detail/${param0} */
export async function getSwimPromotionDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimPromotionDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimPromotionDetailRespVo>(
    `/web/v1/promotion/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 11701-优惠活动列表 POST /web/v1/promotion/pageList */
export async function getSwimPromotionPageList(
  body: API.SwimPromotionPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimPromotionListRespVo>(
    "/web/v1/promotion/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11706-优惠活动状态修改 POST /web/v1/promotion/status/${param0} */
export async function updateSwimPromotionStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateSwimPromotionStatusParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/promotion/status/${param0}`, {
    method: "POST",
    params: {
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** 11704-优惠活动修改 POST /web/v1/promotion/update */
export async function updateSwimPromotion(
  body: API.SwimPromotionUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/promotion/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
